import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {ActivityNotificationService} from "../../activity-notifications/activity-notification.service";
import {DeletedUserActivity} from "./user-activity.model";
import {Store} from "@ngrx/store";
import * as fromStore from '../../store';
import {first} from "rxjs/operators";

@Injectable()
export class ActivityLogDeletedClientsResolver implements Resolve<any|null> {

  constructor(
    private _activityNotificationService: ActivityNotificationService,
    private _store: Store<fromStore.DbStoreState>,
  ) {}

  resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<any> {
    return new Promise((resolve: Function): void => {
      // Check if workspace is available, if not return empty array immediately
      this._store.select(fromStore.getWorkspaceIdEntities)
        .pipe(first())
        .subscribe((workspaceIdEntities) => {
          if (!workspaceIdEntities?.currentWorkspaceId) {
            resolve([]);
            return;
          }

          // Try to load activities with a quick timeout - don't block navigation
          const timeoutPromise = new Promise<DeletedUserActivity[]>((_, reject) => 
            setTimeout(() => reject(new Error('Route resolution timeout')), 3000)
          );

          const loadPromise = this._activityNotificationService.getDeletedClientsActivities()
            .then(activities => activities.map(activity => new DeletedUserActivity(activity)))
            .catch(() => {
              return [];
            });

          Promise.race([loadPromise, timeoutPromise])
            .then(activities => resolve(activities))
            .catch(() => {
              resolve([]);
            });
        });
    });
  }
}